import React from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import FunnelExecutionPane from '../../../containers/funnel/execution/Pane';
import FunnelExecutionSummaryGrid from '../../../containers/funnel/execution/SummaryGrid';
import FunnelExecutionDetails from '../../../containers/funnel/execution/Details';

const FunnelExecutionPaneContainer = ({ tenantId }) => {
  const navigate = useNavigate();
  const params = useParams();

  return (
    <FunnelExecutionPane params={params} navigate={navigate}>
      <FunnelExecutionSummaryGrid
        navigate={navigate}
        tenantId={tenantId}
        additionalStyle={{ padding: '30px 15px 0px' }}
      />
      <FunnelExecutionDetails />
    </FunnelExecutionPane>
  );
};

export default FunnelExecutionPaneContainer;
